import React from 'react';
import { ServiceCard } from './ServiceCard';
import { Wallpaper, Lightbulb, Droplets, Hammer, PaintBucket, Fan, Wrench, BoxIcon } from 'lucide-react';
export function ServicesSection() {
  const services = [{
    title: 'Ceiling & Walls Maintenance',
    description: 'Professional repair and maintenance of all ceiling and wall issues, including painting, plastering, and structural fixes.',
    icon: Wallpaper
  }, {
    title: 'Flooring & Tiling Work',
    description: 'Expert installation, repair, and maintenance of all types of flooring including tile, marble, hardwood, and laminate.',
    icon: BoxIcon
  }, {
    title: 'Electrical & Wiring Services',
    description: 'Comprehensive electrical services from repairs and installations to complete rewiring and system upgrades.',
    icon: Lightbulb
  }, {
    title: 'Plumbing & Water Systems',
    description: 'Professional plumbing solutions including leak detection, pipe repairs, fixture installation, and drainage systems.',
    icon: Droplets
  }, {
    title: 'Carpentry & Woodwork',
    description: 'Custom carpentry services including furniture repair, door installation, cabinetry, and structural woodwork.',
    icon: Hammer
  }, {
    title: 'Interior Decoration & Design',
    description: 'Transform your space with our professional interior decoration and design services tailored to your preferences.',
    icon: PaintBucket
  }, {
    title: 'HVAC & AC Repair',
    description: 'Complete heating, ventilation, and air conditioning services including installation, maintenance, and repairs.',
    icon: Fan
  }, {
    title: 'General Building Repairs',
    description: 'Comprehensive building maintenance and repair services to keep your property in optimal condition year-round.',
    icon: Wrench
  }];
  return <section id="services" className="py-16 md:py-24 bg-gray-50" data-id="element-212">
      <div className="container mx-auto px-4" data-id="element-213">
        <div className="text-center mb-12" data-id="element-214">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-215">
            Our Expertise
          </h2>
          <div className="w-24 h-1 bg-amber-500 mx-auto mb-6" data-id="element-216"></div>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto" data-id="element-217">
            We provide comprehensive maintenance solutions for all your building
            needs, delivered by experienced professionals.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-218">
          {services.map((service, index) => <ServiceCard key={index} title={service.title} description={service.description} icon={service.icon} data-id="element-219" />)}
        </div>
      </div>
    </section>;
}